<template>
  <div
    class="all d-flex flex-column justify-content-center  align-items-center text-center"
  >
    <h1>AI exams</h1>
    <p>Es un producto de AI research</p>
    <a class="link" @click="goToExam()">Ir al examen de admisión 2021-II</a>
  
  </div>
</template>

<script>

export default {
  methods: {
  
    goToExam() {
      this.$router.push({
        name: "login",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  font-weight: bold;
  text-decoration: underline;
  font-size: 20px;
}
.all {
  height: 100vh;
  width: 100vw;
  color: #a7a2a2;
}
</style>
